import { cleanStringForURL } from "app/main/urlFormatter";
import { clientConfig } from "app/config";

export const newsDetailUrl = (newsId: string, title: string) => {
    const cleanTitle = cleanStringForURL(title);
    return `${clientConfig.urlPathPrefixNews}boerse-news/${cleanTitle}/${newsId}`;
};

export const newsOverviewUrl = () => {
    return `${clientConfig.urlPathPrefixNews}`;
};
